import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Reveal, Button } from "../components/ui";
import { PageHero } from "./About";
import SEO from "../components/SEO";
import { optimg } from "../lib/img";
import { ArrowRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data || [])); }, []);

  return (
    <>
      <SEO title="Blog" description="Architecture, construction cost, interior and Vastu tips from GNONS." />
      <PageHero kicker="Blog & Insights" title="Ideas, Tips & Inspiration" subtitle="Design ideas, construction cost guides and planning tips." />
      <section className="py-16 md:py-20 bg-white">
        <div className="container-x">
          {posts.length === 0 ? <p className="text-center text-muted py-12">No blog posts yet.</p> : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {posts.map((p, i) => (
                <Reveal key={p.id} delay={i * 60}>
                  <Link to={`/blog/${p.slug}`} data-testid={`blog-${p.slug}`} className="group block h-full rounded-xl2 border border-line overflow-hidden hover:shadow-lift hover:-translate-y-1 transition-all duration-400">
                    <div className="relative aspect-[16/10] overflow-hidden"><img src={optimg(p.featured_image, { w: 640, h: 400 })} alt={p.title} loading="lazy" className="img-cover group-hover:scale-105 transition-transform duration-700" /></div>
                    <div className="p-6">
                      <span className="text-[11px] font-bold uppercase tracking-wide text-gold">{p.category}</span>
                      <h3 className="mt-2 text-lg font-bold text-ink leading-snug">{p.title}</h3>
                      <p className="mt-2 text-sm text-muted line-clamp-2">{p.excerpt}</p>
                      <span className="inline-flex items-center gap-1.5 mt-4 text-sm font-semibold text-gold">Read More <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" /></span>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
